<template>
  <el-dialog
    title="创建语料"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="语料内容" prop="text">
          <el-input
            type="textarea"
            :rows="4"
            v-model="form.text"
            placeholder="语料内容"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addApi } from '@/api/language'
export default {
  data() {
    return {
      dialogVisible: false,
      form: {},
      rules: {
        text: [
          {
            required: true,
            message: '请输入语料内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    initFun() {
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
      this.form = {}
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    submitFun() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          addApi(this.form).then(res => {
            this.$message.success('提交成功！')
            this.dialogVisible = false
            this.$emit('updateFun')
          })
        }
      })
    }
  }
}
</script>
